export default "__VITE_ASSET__CY67Eomd__ 400w, __VITE_ASSET__BRHdS2dX__ 800w, __VITE_ASSET__BwwNvmJI__ 1024w";